export default function(url, params) {
  return new Promise((resolve,) => {
    this.$http({
      url,
      params,
      responseType: 'arraybuffer',
      mustAll: true,
    }).then(({data, headers})=>{
      const blob = new Blob([data], {type: 'application/vnd.ms-excel'})
      if (headers['content-disposition']) {
        // 含特殊字符+ 所以使用decodeURIComponent
        const fileName = decodeURIComponent(headers['content-disposition'].split(";")[1].split("=")[1])
        console.log(fileName)
        // 非IE下载
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }
      let enc = new TextDecoder('utf-8')
      let res = null
      if(decodeURI(headers['content-disposition']) !== 'undefined'){
        res = {code:'0'} //转化成json对象
      }else{
        res = JSON.parse(enc.decode(new Uint8Array(data))) //转化成json对象
      }
      resolve(res)
    })
  })

};
